import { MY_ACCOUNT_PAGE, NOTIFICATIONS_SETTINGS_PAGE } from "~/utils/url/staticUrls";
import { type TileData } from "~/features/myAccount/dashboard/type";
import { Permission, userHasAnyPermission } from "~/domains/user/utils/permissions";

export function getMyAccountTiles(): TileData[] {
  const canSeeNotifications = userHasAnyPermission(Permission.SEE_NOTIFICATIONS);

  const myAccountTilesArr: TileData[] = [
    {
      url: MY_ACCOUNT_PAGE,
      title: "page.accountSettings.section.myAccount.tile.personalData.title",
      description: "page.accountSettings.section.myAccount.tile.personalData.description",
      testId: "password-settings-tile",
    },
  ];

  canSeeNotifications &&
    myAccountTilesArr.push({
      url: NOTIFICATIONS_SETTINGS_PAGE,
      title: "page.accountSettings.section.myAccount.tile.notifications.title",
      description: "page.accountSettings.section.myAccount.tile.notifications.description",
      testId: "notifications-settings-tile",
    });

  return myAccountTilesArr;
}
